import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { questionShape } from "utils/propTypeShapes"
import { FormsyTimeInput } from "shared/inputs"
import TimeAnswer from "FormSubmission/FormSubmissionTabs/SubmissionContent/answers/TimeAnswer"

const TimeAnswerField = ({
  className = "",
  disabled = false,
  displayTimeAnswerInClockFormat = false,
  edit = false,
  hasBaseInputStyle = false,
  initialValue = "",
  isTaskForm = false,
  placeholder = "",
  question,
  ...rest
}) => {
  const { attributes, required, uuid } = question
  const { setCurrentTime } = attributes

  const currentTime = (new Date()).toTimeString().substring(0, 5)
  const timeValue = (setCurrentTime ? currentTime : "")

  const isNewFormSubmission = !edit && !isTaskForm
  const defaultAnswer = disabled ? "" : timeValue
  initialValue = isNewFormSubmission ? defaultAnswer : initialValue

  let validations = null

  if (!edit) {
    validations = (required) ? { hasValidTime: true } : null
  }

  return (
    <>
      {
        displayTimeAnswerInClockFormat
          ? <TimeAnswer className={clsx("form-input", className)} rawAnswer={initialValue} />
          : (
            <FormsyTimeInput
              className={clsx("form-input-date-time", className)}
              disabled={disabled}
              name={uuid}
              validations={validations}
              value={initialValue}
              hasBaseInputStyle={hasBaseInputStyle}
              placeholder={placeholder}
              {...rest}
            />
          )
      }
    </>

  )
}

TimeAnswerField.propTypes = {
  question: questionShape.isRequired,
  initialValue: types.string,
  disabled: types.bool,
  displayTimeAnswerInClockFormat: types.bool,
  className: types.string,
  placeholder: types.string,
  hasBaseInputStyle: types.bool,
  edit: types.bool,
  isTaskForm: types.bool,
}

export default TimeAnswerField
